export const pages = {
  cart: 'cart',
  checkout: 'checkout',
  'track-order': 'track-order',
  categories: 'categories',
  brands: 'brands',
  prescription: 'prescription',
  user: 'user',
  'user/addresses': 'My Addresses',
  'user/orders': 'My Orders',
  'user/loyalty': 'Loyalty',
  'user/wishlist': 'Favourites',
  'user/wallet': 'My Wallet',
  'user/favourite': 'My Favourite',
  'user/returns': 'My Returns',
};
